import React from "react";
import AddNewTeamStyles from "./AddNewTeam.styles";
import CustomDialog from "../../../../global/components/CustomModal/CustomModal";
import { Box } from "@mui/material";
import LeadPersonalDetails from "../stepper copy/Personal Details/LeadPersonalDetails";
import { Close } from "@mui/icons-material";
const stepData = ["Lead Details", "Additional Information"];

interface CustomProps {
  isDialogOpen: boolean;
  handleCloseAddTeam: Function;
  userId: string;
  setUserId: Function;
  fromSettingOrLogout?: string;
  addNewTeamDialog: any;
  eventForEdit: any;
  leadData: any;
  stageData: any
  formName: any
  stageSourse: any
  responseValuereminder: any,
  responseValueremark: any,
  selectedOptions: any,
  leadOption: any
  type: any,
  allSatgedata: any
  addinationalValue?: any
}

const customerView = (props: CustomProps) => {
  const classes = AddNewTeamStyles;

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: 'smooth',
  //   });
  // }, [activeStep]);
  const totalSteps = () => {
    return stepData.length;
  };

  // step 1 form validation method
  const handleStepOneValidation = () => {
    return true;
  };

  // go to next page method

  // const handleNextValidation = (index: number) => {
  //   try {
  //     if (!props.userId.length) {
  //       throw 'Please Register  user';
  //     }
  //     setActiveStep(index);
  //     nextStep(index - 1);
  //   } catch (error: any) {
  //     openErrorNotification(' Please Register  user');
  //   }
  // };

  const getAllContent = (activeStep: number, leadData: any, stageData: any, formName: any, stageSourse: any, responseValuereminder: any, responseValueremark: any, selectedOptions: any, leadOption: any, type: any, allSatgedata: any, addinationalValue: any) => {
    switch (activeStep) {
      case 0:
        return (
          <LeadPersonalDetails
            userId={props.userId}
            handleCloseAddTeam={props.handleCloseAddTeam}
            nextStep={() => { }}
            setUserId={props.setUserId}
            addNewTeamDialog={props.addNewTeamDialog}
            fromSettingOrLogout={props.fromSettingOrLogout}
            eventForEdit={props.eventForEdit}
            leadData={leadData}
            stageData={stageData}
            formName={formName}
            stageSourse={stageSourse}
            responseValuereminder={responseValuereminder}
            responseValueremark={responseValueremark}
            selectedOptions={selectedOptions}
            type={type}
            // leadOption={leadOption}
            allSatgedata={allSatgedata}
            addinationalValue={addinationalValue}
          />
        );

        break;
    }
  };

  const dialogTitleContent = (leadData: any, stageData: any, formName: any, stageSourse: any, responseValuereminder: any, responseValueremark: any, selectedOptions: any, leadOption: any, type: any, allSatgedata: any, addinationalValue: any) => {
    return (
      <>
        <Box sx={classes.profileWrapper}>{getAllContent(0, leadData, stageData, formName, stageSourse, responseValuereminder, responseValueremark, selectedOptions, leadOption, type, allSatgedata, addinationalValue)}</Box>
      </>
    );
  };

  const dialogHeaderContent = () => {
    return (
      <Box sx={classes.close}>
        <Close onClick={() => props.handleCloseAddTeam()} />
      </Box>
    );
  };

  return (
    <>
      <CustomDialog
        fullScreen={true}
        isDialogOpen={props.isDialogOpen}
        dialogHeaderContent={dialogHeaderContent()}
        dialogTitleContent={dialogTitleContent(props.leadData, props.stageData, props.formName, props.stageSourse, props.responseValuereminder, props.responseValueremark, props.selectedOptions, props.leadOption, props.type, props.allSatgedata, props.addinationalValue)}
        handleDialogClose={props.handleCloseAddTeam}
        type="project"
      />
    </>
  );
};

export default customerView;
